import styled from "styled-components";

export const FieldGrid = styled.div`
	display: grid;
	grid-template-columns: 25rem 25rem;
	grid-gap: 2rem;

	a > img {
		width: 100%;
	}

	ul > li {
		margin-bottom: 0.5rem;
	}

	.full-row {
		grid-column: span 2;
	}
`;
